module.exports = __webpack_public_path__ + "static/013-72049208620a95a748538313670efc58.jpg";